import { useDashboardPageState } from '../../../hooks/useDashboardPageState';
import { useAppointmentTypes } from '../../../api/healthCoach/useAppointmentTypes';
import { MeetingType } from '../../../models/meeting';
import { ProviderType } from '../../../api/types';
import { AppointmentProviderType } from '../../../models/appointment-type';

const providerCategoryToProviderType = (category: string): ProviderType => {
  return (
    Object.values(ProviderType).find(
      (v) => v.toLowerCase() === category.toLowerCase()
    ) ?? ProviderType.Provider
  );
};

export type AppointmentOption = {
  healthieId: number;
  careMemberType: AppointmentProviderType;
  displayName: string;
  meetingType: MeetingType;
  providerType: ProviderType;
  enabled: boolean;
};

export const useSelectMeetingType = () => {
  const {
    state: { user },
  } = useDashboardPageState();

  const { appointmentTypes, isInitialLoading, isLoading, isError } =
    useAppointmentTypes();

  const appointmentOptions: AppointmentOption[] = (appointmentTypes ?? []).map(
    (t) => ({
      healthieId: t.healthie_id,
      careMemberType: t.provider_type,
      displayName: t.appointment_provider ?? t.appointment_type,
      meetingType: t.appointment_type as MeetingType,
      providerType: providerCategoryToProviderType(t.provider_category),
      enabled: t.enabled,
    })
  );

  return {
    appointmentOptions,
    isError: !user || isError,
    isLoading: isLoading || isInitialLoading,
    userId: user?.id,
  };
};
